function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../_snowpack/pkg/react.js';
import { Route, Switch, Redirect } from '../_snowpack/pkg/react-router-dom.js';
import Layout from './modules/layout/index.js';
import { GrowlWrapper } from './modules/growl-wrapper.js';
import DialogWrapper from './modules/dialog/wrapper.js';
import Home from './views/home/home.js';
import Catalogue from './views/catalogue/index.js';
import Explorer from './views/catalogue-explorer/index.js';
import Grids from './views/grids/index.js';
import Fulfilment from './views/fulfilment/index.js';
import InviteTokens from './views/invite-tokens/index.js';
import NotFound404 from './views/not-found-404/index.js';
import Orders from './views/orders/index.js';
import Settings from './views/settings/index.js';
import Shapes from './views/shapes/index.js';
import Topics from './views/topics/index.js';
import WebHooks from './views/webhooks/index.js';
import SignInSignUp from './views/sign-in-sign-up/index.js';
import SignInMagicLinkLandingPage from './views/sign-in-sign-up/magic-link-landing-page.js';
import Insight from './views/insight/index.js';
import Customers from './views/customers/index.js';
import Subscriptions from './views/subscriptions/index.js';
import Plugins from './views/plugins/index.js';
import ContactUs from './views/settings/pricing-plans/contact-us/index.js';
import ActivateSubscription from './views/settings/pricing-plans/create-crystallize-subscription/index.js';
import AddCreditCard from './views/settings/common/add-credit-card/index.js';
import Plans from './views/settings/pricing-plans/index.js';

function Routes(props) {
  const {
    isAuthenticated
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GrowlWrapper, null), /*#__PURE__*/React.createElement(DialogWrapper, null), !isAuthenticated ? /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/signin/magic-link",
    component: SignInMagicLinkLandingPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/signin",
    component: SignInSignUp
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/signup",
    component: SignInSignUp
  })) : /*#__PURE__*/React.createElement(Layout, _extends({
    location: window.location
  }, props), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/signin"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/signup"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/"
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: Home
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/catalogue",
    component: Catalogue
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/graphql-explorer"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: "/catalogue-explorer"
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/topics/:id?",
    component: Topics
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/catalogue-explorer",
    component: Explorer
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/grids/:id?",
    component: Grids
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/shapes/:identifier?",
    component: Shapes
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/insight",
    component: Insight
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/fulfilment",
    component: Fulfilment
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/webhooks",
    component: WebHooks
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/get-access",
    component: InviteTokens
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/tenants/:identifier/plans/crystal",
    component: ContactUs
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/tenants/:identifier/plans/activate-subscription",
    component: ActivateSubscription
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/tenants/:identifier/plans",
    component: Plans
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings/tenants/:identifier/add-payment",
    component: AddCreditCard
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/settings",
    component: Settings
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/orders/",
    component: Orders
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/customers/",
    component: Customers
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/subscription-plans",
    component: Subscriptions
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/plugins",
    component: Plugins
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/contactus",
    component: ContactUs
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: NotFound404
  }))));
}

export default Routes;